var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-tabs"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('div', {
      key: tab.id,
      staticClass: "s-tab",
      class: {
        's-tab--active': tab.id === _vm.activeTab
      },
      on: {
        "click": function click($event) {
          return _vm.handleClickTab(tab);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.text) + " ")]);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }